import React from 'react';
import { useLanguage } from '../lib/i18n';
import { HeartIcon } from 'lucide-react';
interface FooterProps {
  onNavigateHome: () => void;
}
export function Footer({
  onNavigateHome
}: FooterProps) {
  const {
    t
  } = useLanguage();
  const footerLinks = [{
    labelKey: 'nav.vehicles',
    href: '#vozy'
  }, {
    labelKey: 'nav.about',
    href: '#o-nas'
  }, {
    labelKey: 'nav.services',
    href: '#sluzby'
  }, {
    labelKey: 'nav.contact',
    href: '#kontakt'
  }];
  const handleNavClick = (href: string) => {
    if (!window.location.hash.startsWith('#/') || window.location.hash === '#/') {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      onNavigateHome();
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };
  return <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a]" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-78">
          {/* Logo & Description */}
          <div className="lg:col-span-2" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/jWkL4ZwbKDHse1C73JXje9/logoVector.svg" alt="Porsche Top" className="h-16 w-auto brightness-0 invert opacity-50 mb-6" data-id="element-80" />
            <p className="text-[#737373] leading-relaxed max-w-md" data-id="element-81">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-82">
            <h3 className="text-white font-semibold mb-4" data-id="element-83">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-3" data-id="element-84">
              {footerLinks.map(link => <li key={link.href} data-id="element-85">
                  <button onClick={() => handleNavClick(link.href)} className="text-[#737373] hover:text-[#c8a96e] transition-colors" data-id="element-86">
                    {t(link.labelKey)}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-87">
            <h3 className="text-white font-semibold mb-4" data-id="element-88">
              {t('footer.contactTitle')}
            </h3>
            <ul className="space-y-3 text-[#737373]" data-id="element-89">
              <li data-id="element-90">
                <a href="tel:+420603238888" className="hover:text-[#c8a96e] transition-colors" data-id="element-91">
                  +420 603 238 888
                </a>
              </li>
              <li data-id="element-92">
                <a href="mailto:info@porschetop.cz" className="hover:text-[#c8a96e] transition-colors" data-id="element-93">
                  info@porschetop.cz
                </a>
              </li>
              <li data-id="element-94">{t('contact.addressValue')}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#2a2a2a] flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-95">
          <p className="text-[#737373] text-sm flex items-center gap-1" data-id="element-96">
            {t('footer.madeWith').split('❤️')[0]}
            <HeartIcon className="w-4 h-4 text-[#c8a96e] fill-[#c8a96e] inline" data-id="element-97" />
            {t('footer.madeWith').split('❤️')[1]}
          </p>
        </div>
      </div>
    </footer>;
}